import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b70319e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "description-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "text-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDescriptionField && _ctx.showDescriptionField(...args)))
        }, " Добавить описание "))
      : _createCommentVNode("", true),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock(_component_FormField, {
          key: 1,
          value: _ctx.description,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
          name: "description",
          label: "Описание",
          type: "textarea"
        }, null, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}